import React, {FunctionComponent, useContext} from "react";
import "./InvoiceSummaryRows.scss";
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import {OptionContext} from "../../context/OptionContext";
import {useCardFeeRecoveryContext} from "../../context/CardFeeRecoveryContext";
import {InvoicePaymentAmountRows} from "./InvoicePaymentAmountRows";

export const InvoiceSummaryRows: FunctionComponent = () => {
    const invoice: Invoice = useContext(InvoiceContext);
    const optionContext = useContext(OptionContext);
    const cardFeeRecovery = useCardFeeRecoveryContext();
    const isShowCardFeeRecoverySummary = cardFeeRecovery.isEnabled && !optionContext.isFallbackToPricesWithoutCardFeeRecovery;

    return (
        <>
            {
                invoice.is_subtotal_visible ?
                    <div className="summary-item">
                        <p>Subtotal: </p>
                        <p>{optionContext.invoiceSubtotal}</p>
                    </div> : null
            }
            {
                invoice.is_surcharge_visible
                    ? <div className="summary-item">
                        <p>{invoice.surcharge_title || 'Surcharge:'}({invoice.surcharge_amount})</p>
                        <p>{optionContext.invoiceSurcharge}</p>
                    </div>
                    : null
            }

            {
                invoice.is_discount_visible
                    ? <div className="summary-item">
                        <p>{invoice.discount_title || 'Discount:'}({invoice.discount_amount}) </p>
                        <p>{optionContext.invoiceDiscount}</p>
                    </div>
                    : null
            }

            {
                invoice.is_tax_visible && invoice.sales_tax_rate_totals
                    ? invoice.sales_tax_rate_totals.map((salesTaxRateTotal) => <div
                        key={`${salesTaxRateTotal.name}-${salesTaxRateTotal.percent}`}
                        className="summary-item">
                        <p>{salesTaxRateTotal.name} - {salesTaxRateTotal.percent}%</p>
                        <p>{salesTaxRateTotal.amount}</p>
                    </div>)
                    : null
            }

            {
                invoice.is_tax_visible
                    ? <div className="summary-item">
                        <p>{invoice.total_tax_name}</p>
                        <p>{optionContext.invoiceTax}</p>
                    </div>
                    : null
            }

            {
                isShowCardFeeRecoverySummary
                    ? <>
                        <div className="summary-item total-summary-item">
                            <p>Total Card Price: </p>
                            <p>{optionContext.invoiceTotal}</p>
                        </div>
                        <div className="summary-item total-summary-item">
                            <p>
                                Total {invoice.is_ach_payment_available ? 'ACH Price' : 'Cash Price'}
                                {cardFeeRecovery.isShowDiscountPercentageOnInvoice ? ` (${cardFeeRecovery.feePercent}% discount)` : ''}:
                            </p>
                            <p>{optionContext.invoiceTotalWithoutCardFeeRecovery}</p>
                        </div>
                    </>
                    : <div className="summary-item total-summary-item">
                        <p>Total: </p>
                        <p>{optionContext.invoiceTotal}</p>
                    </div>
            }

            {
                invoice.is_amount_paid_visible
                    ? <div className="summary-item total-summary-item">
                        <p>Amount Paid: </p>
                        <p>{invoice.amount_paid}</p>
                    </div>
                    : null
            }

            {
                invoice.is_invoice && invoice.is_amount_due_visible && (!invoice.is_payment_available || optionContext.getPaymentAmountFormatted() !== optionContext.invoiceAmountDue)
                    ? invoice.is_payment_available
                        ? <div className="summary-item total-summary-item">
                            <p>Amount Remaining: </p>
                            <p>{optionContext.invoiceAmountDue}</p>
                        </div>
                        : isShowCardFeeRecoverySummary
                            ? <>
                                <div className="summary-item total-summary-item">
                                    <p>Amount Due (Card): </p>
                                    <p>{optionContext.invoiceAmountDue}</p>
                                </div>
                                <div className="summary-item total-summary-item">
                                    <p>Amount Due ({invoice.is_ach_payment_available ? 'ACH' : 'Cash'}): </p>
                                    <p>{optionContext.invoiceAmountDueWithoutCardFeeRecovery}</p>
                                </div>
                            </>
                            : <div className="summary-item total-summary-item">
                                <p>Amount Due: </p>
                                <p>{optionContext.invoiceAmountDue}</p>
                            </div>
                    : null
            }

            <InvoicePaymentAmountRows/>
        </>
    );
};
